import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "rounded-lg border border-slate-200 bg-white p-5 shadow-[0_12px_30px_rgba(15,23,42,0.06)]" }
const _hoisted_3 = { class: "flex flex-wrap items-start justify-between gap-4" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2" }
const _hoisted_5 = { class: "border-b border-slate-200 bg-slate-50 px-4 py-4" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "inline-flex h-9 w-9 items-center justify-center rounded-lg bg-teal-100 text-teal-800" }
const _hoisted_8 = { class: "text-[17px] mb-0 font-black text-slate-950" }
const _hoisted_9 = { class: "divide-y divide-slate-100" }
const _hoisted_10 = { class: "flex cursor-pointer list-none items-start justify-between gap-3 text-[15px] font-extrabold leading-6 text-slate-900" }
const _hoisted_11 = { class: "mt-3 font-medium leading-6 text-slate-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "min-w-0" }, [
          _createElementVNode("p", { class: "text-[24px] font-black leading-8 text-slate-950" }, " Câu hỏi thường gặp "),
          _createElementVNode("p", { class: "mt-2 max-w-4xl text-[15px] font-medium leading-6 text-slate-600" }, " Tổng hợp các lỗi và thắc mắc thường gặp khi sử dụng hệ thống Zalo OA. ")
        ], -1)),
        _createVNode(_component_RouterLink, {
          to: "/guide",
          class: "inline-flex min-h-10 items-center gap-2 rounded-lg border border-teal-200 bg-teal-50 px-4 py-2 text-sm font-extrabold !text-teal-800 !no-underline transition hover:bg-teal-100"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "pi pi-book" }, null, -1),
            _createTextVNode(" Xem hướng dẫn ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.faqGroups, (group) => {
        return (_openBlock(), _createElementBlock("div", {
          key: group.title,
          class: "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_12px_30px_rgba(15,23,42,0.06)]"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("i", {
                  class: _normalizeClass(["pi", group.icon])
                }, null, 2)
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(group.title), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
              return (_openBlock(), _createElementBlock("details", {
                key: item.question,
                class: "group p-4"
              }, [
                _createElementVNode("summary", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(item.question), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "pi pi-chevron-down ml-2 mt-1 text-xs text-slate-400 transition group-open:rotate-180" }, null, -1))
                ]),
                _createElementVNode("p", _hoisted_11, _toDisplayString(item.answer), 1)
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}